import * as React from "react";
function SearchRemoveIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.125 9.812A8.313 8.313 0 1 1 9.811 1.5h.002a8.31 8.31 0 0 1 8.312 8.312m1.5 0C19.625 4.393 15.232 0 9.813 0h-.002C4.39 0-.002 4.395-.001 9.814c0 5.42 4.395 9.813 9.814 9.812 5.42 0 9.813-4.395 9.812-9.814M6.038 7.098l6.364 6.364a.75.75 0 1 0 1.06-1.06L7.098 6.038a.75.75 0 0 0-1.06 1.06m1.06 6.364 6.364-6.364a.75.75 0 0 0-1.06-1.06l-6.364 6.364a.75.75 0 1 0 1.06 1.06m8.593 3.288 7.029 7.03a.75.75 0 0 0 1.06-1.06l-7.029-7.03a.75.75 0 0 0-1.06 1.06"
  }));
}
export default SearchRemoveIcon;